<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    <div id="breadcrumb">
        <div class="container">
            <ul>
                <li><router-link tag="a" to="/">Inicio</router-link></li>
                <li>Quienes somos</li>
            </ul>
        </div>
    </div>
    <!-- /breadcrumb -->

    <div class="bg_color_1 about-us-back">
        <div class="container margin_120_95">
            <div class="main_title">
                <h1>Bienvenido a doctorconsultas</h1>
                <p>La plataforma que conecta pacientes con médicos especialistas.</p>
            </div>
            <div class="row ">
                <div class="col-12">
                    <p class="text-center">
                    Queremos que encuentres rápidamente al médico que necesitás y reserves tu consulta de la manera más fácil. <br>
                    Creemos que tu experiencia debe ser muy agradable; y damos lo mejor de nosotros para ayudarte a encontrar la mejor atención médica posible, 
                    en cualquier momento y en cualquier lugar. <br>
                    En DoctorConsultas encontrás una gran variedad de especialistas comprometidos a solucionar tus necesidades médicas.  <br>
                    Tu salud y tu tiempo valen mucho, por eso trabajamos para acortar tu tiempo de espera y que recibas un servicio de gran calidad. <br>
                    </p>
                    <p  class="text-center"><em>* DoctorConsultas.com no presta servicios de salud, solo vincula a las partes.     </em></p>
                </div>
            </div>
        </div>
    </div>
    

    <Footer></Footer>

</div>
</template>

<script>
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default {
    name: 'About',
    metaInfo: {
		title: 'Quienes somos',
	},
    components: {
        Navigation,
        Footer,
    },
    data() {
        return {

        }
    },

}
</script>

<style scoped>
.about-us-back{
    background-image: url('../assets/img/bg-about-us.jpg');
    background-size: cover;
    background-position: center center;
}
.about-us-back p{
    color: #000;
}
</style>
